import React, { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import "./Users.css"
import "react-dates/initialize"
import "react-dates/lib/css/_datepicker.css"
import moment from "moment"
import "moment/locale/es"
import UserForm from "./Components/UserForm"
import api from "../../utils/axios"

const EditUser = () => {
	const [isAdmin, setIsAdmin] = useState(false)
	const navigate = useNavigate()
	const { id } = useParams()
	const [fname, setFname] = useState("")
	const [lname, setLname] = useState("")
	const [position, setPosition] = useState("")
	const [role, setRole] = useState("")
	const [roleName, setRoleName] = useState("")
	const [email, setEmail] = useState("")
	const [username, setUsername] = useState("")
	const [labOrders, setLabOrders] = useState(false)
	const [biochemicalsNotAllowed, setBiochemicalsNotAllowed] = useState(false)
	const [isBiochemicalRole, setIsBiochemicalRole] = useState(false)

	// Buscador de categorías de varios
	const [categoriesFound, setCategoriesFound] = useState([])
	const [categoriesAssigned, setCategoriesAssigned] = useState([])

	// Buscador de categorías de varios
	const [labsAssigned, setLabsAssigned] = useState([])


	// Date Range Picker
	moment.locale("es") // Establece el idioma para Moment.js
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();

	const getCategoryById = async (id) => {
		const response = await api.get(`/categories/${id}`)

		return response.data
	}

	useEffect(() => {
		; (async () => {
			try {
				const response = await api.get("/categories")

				setCategoriesFound(response.data.categories)

				await api.get(`/users/${id}`).then(async response => {
					setFname(response.data.fname)
					setLname(response.data.lname)
					setPosition(response.data.position)
					setRole(response.data.role)
					setRoleName(response.data.roleName)
					setUsername(response.data.username)
					setEmail(response.data.email)
					setRole(response.data.roleName)
					setLabOrders(response.data.labOrders)
					setBiochemicalsNotAllowed(response.data.biochemicalsNotAllowed)
					setStartDate(moment(response.data.startDateOrder))
					setEndDate(moment(response.data.endDateOrder))
					setIsBiochemicalRole(response.data.biochemicalRole)

					// Procesa las categorías y labs
					const categories = await Promise.all(response.data.categoriesAssigned.map(category => getCategoryById(category)))

					setCategoriesAssigned(categories)
					setLabsAssigned(response.data.labs)
					// console.log("labs del usuario:", response.data.labs)
					// setLabsAssigned(response.data.labs)
				})
			} catch (error) {
				console.log(error)
			}
		})()

	}, [])

	return <UserForm type="editUser" id={id} fname={fname} lname={lname} position={position} role={role} roleName={roleName} email={email} username={username} labOrders={labOrders} biochemicalsNotAllowed={biochemicalsNotAllowed} categoriesFound={categoriesFound} categoriesAssigned={categoriesAssigned} labsAssigned={labsAssigned} startDate={startDate} endDate={endDate} isBiochemicalRole={isBiochemicalRole} />
}

export default EditUser
